/**
 * Composant de redirection intelligente pour la route racine
 * 
 * Redirige selon le type d'utilisateur :
 * - Médecin (avec medecin_id) → /portail-medecin
 * - Responsable (sans medecin_id) → /responsable
 * - Non authentifié → /auth
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';

export default function HomeRedirect() {
  const { loading, isAuthenticated, user } = useAuth();

  // Pendant le chargement
  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'Inter, sans-serif',
          color: '#4b5563',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '16px', marginBottom: '8px' }}>Chargement…</div>
          <div style={{ fontSize: '14px', color: '#6b7280' }}>Vérification de la session…</div>
        </div>
      </div>
    );
  }

  // Si non authentifié, rediriger vers /auth
  if (!isAuthenticated) {
    window.location.replace("/auth");
    return null;
  }

  // Si l'utilisateur a un medecin_id, c'est un médecin → /portail-medecin
  if (user?.medecin_id) {
    return <Navigate to="/portail-medecin" replace />;
  }

  // Si c'est un responsable global (sans medecin_id), rediriger vers /responsable
  if (user?.role === 'responsable') {
    return <Navigate to="/responsable" replace />;
  }

  // Si c'est un responsable sectoriel (thoracique) sans medecin_id → portail médecin
  // (normalement il a un medecin_id, donc ce cas est déjà couvert ci-dessus)
  if (user?.role === 'responsable_thoracique') {
    return <Navigate to="/portail-medecin" replace />;
  }

  // Par défaut, rediriger vers /portail-medecin
  return <Navigate to="/portail-medecin" replace />;
}
